import { Facebook, Youtube, Instagram } from 'lucide-react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-[#0B1437] to-[#0A0F1E] text-white pt-12 pb-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-3">Contato</h3>
            <p className="text-gray-400 text-sm mb-1">(27) 9 9879-7619</p>
            <p className="text-gray-400 text-sm">(27) 9 9713-9118</p>
          </div>

          {/* Partnerships */}
          <div>
            <h3 className="font-bold text-lg mb-3">Parcerias</h3>
            <a
              href="mailto:comercial@englishwork.com.br"
              className="text-gray-400 text-sm hover:text-blue-400 transition-colors">

              comercial@englishwork.com.br
            </a>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-bold text-lg mb-3">Suporte</h3>
            <a
              href="mailto:atendimento@englishwork.com.br"
              className="text-gray-400 text-sm hover:text-blue-400 transition-colors">

              atendimento@englishwork.com.br
            </a>
          </div>

          {/* Social & App */}
          <div>
            <h3 className="font-bold text-lg mb-3">Redes Sociais</h3>
            <div className="flex gap-3 mb-4">
              <a
                href="https://www.facebook.com/profile.php?id=100089366183716"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="Facebook">

                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="https://www.youtube.com/@englishwork"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-600 transition-colors"
                aria-label="YouTube">

                <Youtube className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/englishwork_br/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-pink-600 transition-colors"
                aria-label="Instagram">

                <Instagram className="w-4 h-4" />
              </a>
            </div>

            <div className="flex gap-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.ewpass.mobile&hl=pt_BR"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 transition-colors text-xs font-medium px-3 py-2 rounded-lg">

                Google Play
              </a>
              <a
                href="https://apps.apple.com/br/app/ew-pass/id6752664261"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 transition-colors text-xs font-medium px-3 py-2 rounded-lg">

                App Store
              </a>
            </div>
          </div>
        </div>

        {/* Legal */}
        <div className="border-t border-white/10 pt-6 space-y-2 text-center">
          <p className="text-gray-500 text-xs">

          </p>
          <p className="text-gray-500 text-xs">
            English Work Sociedade de Ensino Ltda &copy; {currentYear} - Todos os direitos reservados | CNPJ: 48.620.557/0001-51
          </p>
          <p className="text-gray-500 text-xs">
            Rua João Pessoa de Mattos, 530. CEP 29101-115
          </p>
        </div>
      </div>
    </footer>);

}

export default Footer;